module.exports = __webpack_public_path__ + "img/footer-5.5bfbf71a.png";